export default [
  {
    path: "/relatorios",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "relatorios_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Relatorios", to: "relatorios_list" }],
          permission: "relatorio:view",
          title: "Relatorios",
        },
      },

      {
        name: "relatorios_oportunidades",
        path: "oportunidades",
        component: () => import("./pages/Oportunidades"),
        meta: {
          breadcrumbs: [
            { label: "Relatorios de Oportunidades", to: "relatorios_list" },
          ],
          permission: "relatorio:edit",
          title: "Relatorios - Oportunidades",
        },
      },
    ],
  },
];
